import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type ReStudentSummaryRoute from 'teacher-ui-client/reporting/ui-scope/re/student-summary/route'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor('reporting.ui-scope.re.student-summary') as ModelFor<ReStudentSummaryRoute>

    const statsScope: StudentScope = { scope: 'student', ids: [student.id] }

    const product: LegacyProductRe = 're'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      student,
      students: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests(product: LegacyProductRe, scope: StudentScope, period: NormalizedInterval) {
    const { studentEvents } = this
    return RSVP.hash({
      drivingTestDetailsTotalsByMonth: studentEvents.drivingTestDetailsTotalsByMonth(product, scope, period),
      drivingTestDetailsHistory: studentEvents.drivingTestDetailsHistory(product, scope, period),
    })
  }
}
